import { atomFamily } from 'recoil';
import { ITabOption } from 'shared-state/tabs/types';

export const aTabOptionList = atomFamily<ITabOption[], string>({ key: 'aTabOptionList', default: [] });
